export default "__VITE_ASSET__Chu7BcCK__"